export default __webpack_public_path__ + "static/media/adobeIcon.ac1421a1.webp";